// extracted by mini-css-extract-plugin
export default {"secondary":"paragraph_secondary__Hfag+","tertiary":"paragraph_tertiary__nDVr9","meta":"paragraph_meta__YXgW6","ellipsisOverflow":"paragraph_ellipsisOverflow__Iwn3f"};